import styled from '@emotion/styled';
import React from 'react';
import { WidgetItemPromoted } from './apiService';
import PromotedCard from './PromotedCard';
import { Text } from './styles';
import PageOverlay from './styles/PageOverlay';

const Container = styled.div(({ theme }) => ({
  display: 'grid',
  gridTemplateRows: 'auto',
  gap: theme.spacing(2),
  gridTemplateAreas: '"item0 item0" "item1 item2"',
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    marginLeft: `-${theme.spacing(2)}`,
    gap: 0,
  },
}));

const CardWrapper = styled.div<{ index: number }>(({ theme, index }) => ({
  gridArea: `item${index}`,
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    width: `${100 / 3}%`,
    marginLeft: theme.spacing(2),
  },
}));

export default function PromotedCardList({ items, title }: { items: WidgetItemPromoted[]; title: string }) {
  const [activeCardId, setActiveCardId] = React.useState<string | null>(null);

  return (
    <>
      <PageOverlay visible={!!activeCardId} />
      {title && (
        <Text variant="h2" weight="medium" mb={1}>
          {title}
        </Text>
      )}
      <Container>
        {items.map(
          (
            {
              content_id: contentId,
              image: { path } = {},
              video_content: content,
              navigation_configuration: navigationConfiguration,
              title,
              description,
            },
            index,
          ) => {
            if (navigationConfiguration?.navigation_type === 'content' && !content) return null;
            const id = `${content?.id || content?.short_id || contentId || 'promoted-item'}-${index}`;
            const active = id === activeCardId;
            return (
              <CardWrapper index={index} key={id} style={{ zIndex: active ? 9999 : 1 }}>
                <PromotedCard
                  id={id}
                  imagePath={path}
                  content={content}
                  navigationConfiguration={navigationConfiguration}
                  title={title}
                  description={description}
                  active={active}
                  onHoverChange={setActiveCardId}
                />
              </CardWrapper>
            );
          },
        )}
      </Container>
    </>
  );
}
